import { Area, AreaChart, ResponsiveContainer } from 'recharts';

interface DashboardAreaChartProps<TData extends Record<string, unknown>> {
  data: TData[];
  yKey: keyof TData;
  stroke?: string;
  gradientId?: string;
}

const DashboardAreaChart = <TData extends Record<string, unknown>>({
  data,
  yKey,
  stroke = '#16a34a',
  gradientId = 'dashboard-area-chart-gradient'
}: DashboardAreaChartProps<TData>) => {
  if (data.length === 0) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-sm text-gray-500">No data available</p>
      </div>
    );
  }

  return (
      <ResponsiveContainer width="100%" height={"100%"}   >
        <AreaChart data={data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={stroke} stopOpacity={0.35} />
              <stop offset="95%" stopColor={stroke} stopOpacity={0.04} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey={String(yKey)}
            stroke={stroke}
            strokeWidth={2}
            fill={`url(#${gradientId})`}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
  );
};

export default DashboardAreaChart;
